import { Link } from "react-router-dom";

const Articles = () => {
  return (
    <div className="pt-10 pb-20 w-full flex flex-row justify-center">
      <div style={{ maxWidth: 1200 }}>
        <div
          data-aos="fade-up"
          className="uppercase lg:text-5xl md:text-3xl xl:text-6xl text-2xl py-5  pl-4 md:pl-0 md:col-start-2 md:col-span-10 col-span-12"
        >
          ARTICLES
        </div>
        <div className="grid w-full   grid-cols-1 lg:grid-cols-2 gap-10">
          <div
            data-aos="zoom-out"
            className="shadow-xl bg-white p-6 flex flex-col items-start my-4"
            style={{
              boxShadow: "0 0 20px rgba(0,0,0,.2)",
            }}
          >
            <div className="text-3xl font-black text-left my-4">
              TECHNICAL SUPPORT AGREEMENTS (TSAS): LEGAL REQUIREMENTS
            </div>
            <div align="justify">
              On 25 April 2025, Tanzania introduced the Mining (Technical
              Support to Holders of Primary Mining Licences) Regulations, 2025
              (G.N. No. 260). These regulations allow Primary Mining Licence
              (PML) holders to enter into legally recognized Technical Support
              Agreements (TSAs) with qualified individuals or entities to
              enhance mining operations. This update summarizes the legal
              requirements for TSAs and what stakeholders need to know...
            </div>
            <Link
              to={`articles/legal_requirements`}
              className="flex  mt-4 p-2 cursor-pointer transform hover:scale-2 bg-red-700 text-white "
            >
              Read More
            </Link>
          </div>
          <div
            data-aos="zoom-in"
            className="shadow-xl bg-white p-6 flex flex-col items-start my-4"
            style={{
              boxShadow: "0 0 20px rgba(0,0,0,.2)",
            }}
          >
            <div className="text-3xl font-black text-left my-4">
              Legal Update: New Sustainability Bonds Regulations in Tanzania
            </div>
            <div align="justify">
              The Capital Markets and Securities (Corporate and Subnational
              Sustainability Bonds) Regulations, are officially issued under
              Government Notice No. 302 on May 23, 2025, according to the
              Capital Markets and Securities Act (Cap. 79). These Regulations
              establish a comprehensive legal framework for the issuance,
              management, and oversight of sustainability- related bonds within
              the United Republic of Tanzania...
            </div>
            <Link
              to={`articles/New_Sustainability_Bonds_Regulations_in_Tanzania`}
              className="flex  mt-4 p-2 cursor-pointer transform hover:scale-2 bg-red-700 text-white "
            >
              Read More
            </Link>
          </div>
          <div
            data-aos="zoom-out"
            className="shadow-xl bg-white p-6 flex flex-col items-start my-4"
            style={{
              boxShadow: "0 0 20px rgba(0,0,0,.2)",
            }}
          >
            <div className="text-3xl font-black text-left my-4">
              Legal Update: Compliance with Section 36 of the Consumer
              Protection Act – Registration of Express Terms with the Fair
              Competition Commission (FCC)
            </div>
            <div align="justify">
              The Consumer Protection Act, Cap 412 of the Laws of Tanzania (the
              CPA), imposes a crucial regulatory obligation under Section 36,
              which requires all suppliers of goods and services to register
              express terms of their consumer contracts with the Fair
              Competition Commission (FCC) before applying those terms in any
              transaction with consumers...
            </div>
            <Link
              to={`articles/Compliance_with_Section_36_of_the_Consumer`}
              className="flex  mt-4 p-2 cursor-pointer transform hover:scale-2 bg-red-700 text-white"
            >
              Read More
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Articles;
